'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _StringColumn = require('./StringColumn');

var _Select2BaseColumn2 = require('./Select2BaseColumn');

var _Select2BaseColumn3 = _interopRequireDefault(_Select2BaseColumn2);

var _odataUri = require('../../utils/odata-uri');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var log = require('debug')('linksoft:datatables:LookupColumn');

var LookupColumn = function (_Select2BaseColumn) {
	_inherits(LookupColumn, _Select2BaseColumn);

	function LookupColumn() {
		_classCallCheck(this, LookupColumn);

		return _possibleConstructorReturn(this, (LookupColumn.__proto__ || Object.getPrototypeOf(LookupColumn)).apply(this, arguments));
	}

	_createClass(LookupColumn, [{
		key: 'displayValue',
		value: function displayValue(value) {
			var _this2 = this;

			var output = this.multiSelect ? (value || []).map(function (v) {
				return _this2.getLookupName(v);
			}).join(', ') : this.getLookupName(value);
			return output || _StringColumn.noValue;
		}
	}, {
		key: 'getLookupName',
		value: function getLookupName(value) {
			return value && value.name || value;
		}
	}, {
		key: 'getCustomFilter',
		value: function getCustomFilter() {
			return this.options && this.options.select2Filter;
		}
	}, {
		key: 'createEditor',
		value: function createEditor(value, id) {
			var _this3 = this;

			var dataUrl = this.options.dataUrl;

			var customFilter = this.getCustomFilter();
			if (!dataUrl) {
				log('Column with lookup filter requires "dataUrl" to be defined. %o', this.options);
				return null;
			}
			var selected = (this.multiSelect ? value : [value]).map(function (item) {
				return _this3.getSelectedOption(item);
			});
			var multi = this.multiSelect ? ' multiple="multiple" ' : '';
			return '<select class="form-control table-input" \n                    data-ajax--url="' + dataUrl + '" \n                    data-odata="true"\n                    ' + (customFilter ? 'data-odata-filter="' + customFilter + '"' : '') + '\n                    data-allow-clear="true" \n                    data-width="resolve" ' + multi + '\n                    data-placeholder="' + this.api.i18n('Select2Placeholder', 'Choose...') + '">' + selected + '</select>';
		}
	}, {
		key: 'getSelectedOption',
		value: function getSelectedOption(item) {
			return item ? '<option selected="selected" value="' + item.id + '">' + item.name + '</option>' : '';
		}
	}, {
		key: 'getEditorValue',
		value: function getEditorValue(cellElement) {
			var _this4 = this;

			var $el = (0, _jquery2.default)(cellElement).find('.table-input');
			var value = $el.val() || (this.multiSelect ? [] : null);
			if (this.multiSelect) {
				return (value || []).map(function (v) {
					return _this4.getItemById($el, v);
				}).filter(function (v) {
					return v;
				});
			}
			return this.getItemById($el, value);
		}
	}, {
		key: 'getItemById',
		value: function getItemById($select, value) {
			var id = parseInt(value, 10);
			if (isNaN(id)) return null;
			var name = $select.find('option[value=\'' + id + '\']').text();
			return { id: id, name: name };
		}

		// -------------- FILTERS --------------------


	}, {
		key: 'createFilter',
		value: function createFilter() {
			var dataUrl = this.options.dataUrl;

			var customFilter = this.getCustomFilter();
			if (!dataUrl) {
				log('Column with lookup filter requires "dataUrl" to be defined. %o', this.options);
				return null;
			}
			return '<div class="input-group">\n\t<select class="form-control table-filter"\n\t\t\t\t\tdata-ajax--url="' + dataUrl + '"\n\t\t\t\t\t' + (customFilter ? 'data-odata-filter="' + customFilter + '"' : '') + '\n\t\t\t\t\tdata-odata="true"\n\t\t\t\t\tdata-width="resolve"\n\t\t\t\t\tdata-placeholder="' + this.api.i18n('Select2Placeholder', 'Choose...') + '"></select></div>';
		}
	}, {
		key: 'buildFilterExpression',
		value: function buildFilterExpression(fieldName, columnFilter) {
			return this.options.isArray ? _odataUri.filters.anyEquals(fieldName, parseInt(columnFilter, 10), 'id') : _odataUri.filters.equals(fieldName, parseInt(columnFilter, 10), 'id');
		}
	}, {
		key: 'multiSelect',
		get: function get() {
			return !!this.options.isArray;
		}
	}, {
		key: 'orderByProp',
		get: function get() {
			return this.sourceProp + '.name';
		}
	}]);

	return LookupColumn;
}(_Select2BaseColumn3.default);

exports.default = LookupColumn;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/LookupColumn.js
// module id = 489
// module chunks = 0